import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export default function ViewAllLink({ to, level, onItemMouseClick, onDeactivate }) {
  return (
    <li className="view-link leaf">
      <Link
        className="level-item-link"
        to={to}
        onClick={onItemMouseClick}
        onTouchStart={onDeactivate}
      >
        <span className="view-link-label">View all</span> {level.name}
      </Link>
    </li>
  );
}

ViewAllLink.propTypes = {
  to: PropTypes.string.isRequired,
  level: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  onItemMouseClick: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
};
